import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";



const API_BASE_URL = "/api"; //the setupProxy.js handles everything else

// const API_BASE_URL =
//     process.env.REACT_APP_ENV === "development"
//         ? `https://localhost:${process.env.ASPNETCORE_HTTPS_PORT}/api`
//         : "/api";

export default class Api {

    static ApiKey = ""
    
    static setAuthorizationHeader(jwt) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
  
      axios.interceptors.response.use(undefined, function (error) {
        if (error.response.status === 401) {
          const { loginWithPopup } = useAuth0();
          loginWithPopup();
        }
      });
    }

    //get requests//
    
    static async getUserInfo(){
      try {
        let response = await axios.get(`${API_BASE_URL}/User`);
        return response.data;
      }catch (error){
        console.error(error);
        return null;
      }
    }

    static async getUsersOrg(){
      //code to get user info to get their org from api here
      try {
        let response = await axios.get(`${API_BASE_URL}/Organization`);
        return response.data;
      }catch (error){
        console.error(error);
        return null;
      }
    }

    static async getAllUsersForOrg(){
      try {
        let response = await axios.get(`${API_BASE_URL}/User/all/org`)
        return response.data;
      }catch (error){
        console.error(error);
        return [];
      }
    }

    static async getAllUsers(){
      try {
        let response = await axios.get(`${API_BASE_URL}/User/all`)
        return response.data;
      }catch (error){
        console.error(error);
        return [];
      }
    }


    static async GetOrgWithCurrentDeploy(){
      try {
        let response = await axios.get(`${API_BASE_URL}/Organization/GetWithCurrentDeploy`)
        return response.data;
      }catch (error){
        console.error(error);
        return null;
      }
    }

    // static async getSampleData() {
    //     try {
    //         let response = await axios.get(`${API_BASE_URL}/SampleData`);
    //         return response.data;
    //     } catch (error) {
    //         console.error(error);
    //         return null;
    //     }
    // }

    static async getCallDifference(solutionId, zeroPeakComparison){
      try {
        let response = await axios.get(`${API_BASE_URL}/Solution/calls/${solutionId}/${zeroPeakComparison}`);
        return response.data;
      } catch (error){
        console.error(error);
        return null;
      }
    }

    static async getAllSolutions(){
      try {
        let response = await axios.get(`${API_BASE_URL}/Solution/All`);
        return response.data;
      }catch (error) {
        console.error(error);
        return null;
      }
    }

    static async getSingleSolution(id){
      try {
        let response = await axios.get(`${API_BASE_URL}/Solution/${id}`);
        return response.data;
      }catch (error) {
        console.error(error);
        return null;
      }
    }

    static async getSolutionExport(id){
      try {
        let response = await axios.get(`${API_BASE_URL}/Solution/Json/${id}`, {
         responseType: "text",
         transformResponse: [r => r]
        });
        return response.data;
      }catch(error){
        console.error(error);
        return null;
      }
    }

    static async getAllStations(){
      try {
        let response = await axios.get(`${API_BASE_URL}/Station/All`);
        return response.data;
      }catch (error){
        console.error(error);
        return null;
      }
    }

    static async getAllAssignments(){
      try{
        let response = await axios.get(`${API_BASE_URL}/PauAssignment/All`);
        return response.data;
      }catch (error){
        console.error(error);
        return false;
      }
    }

    static async getAllMetrics(){
      try{
        let response = await axios.get(`${API_BASE_URL}/Metric/all`);
        return response.data;
      }catch (error){
        console.error(error);
        return null;
      }
    }

    static async getMetricForSolution(id){
      try{
        let response = await axios.get(`${API_BASE_URL}/Metric/FromSolution/${id}`);
        return response.data;
      }catch(error){
        console.error(error);
        return null;
      }
    }

    static async getAllOptimizationRequests(){
      try {
        let response = await axios.get(`${API_BASE_URL}/Optimization/All`);
        return response.data;
      }catch(error){
        console.error(error);
        return null;
      }
    }

    static async getAllCompleteOptimizationRequests(){
      try {
        let response = await axios.get(`${API_BASE_URL}/Optimization/Complete`);
        return response.data;
      }catch(error){
        console.error(error);
        return null;
      }
    }

    static async getOptimizationRequestById(id){
      try {
        let response = await axios.get(`${API_BASE_URL}/Optimization/${id}`);
        return response.data;
      }catch (error){
        console.error(error);
        return null;
      }
    }

    static async getAssignableRoles(){
      try {
        let response = await axios.get(`${API_BASE_URL}/Role/assignable`);
        console.log(response.data);
        return response.data;
      }catch(error){
        console.error(error);
        return null;
      }
    }

    //post requests
    static async postNewSolution(newSolnName){
      try {
        let response = await axios.post(`${API_BASE_URL}/Solution/${newSolnName}`, {}, {
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.status === 200;
      }catch (error) {
        console.error(error);
        return false;
      }
    }

    static async postImportSolution(solutionText){
      try {
        let key = JSON.stringify(solutionText);
        let response = await axios.post(`${API_BASE_URL}/Solution/FromJson`, key, 
        {
          headers: {
            "ApiKey": this.ApiKey,
            'Content-Type': 'application/json'
          }
        });
        return response.status === 200;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async postNewStation(newStation){
      try{
        let response = await axios.post(`${API_BASE_URL}/Station`, newStation, {
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.status === 200;
      }catch (error){
        console.error(error);
        return false;
      }
    }

    static async postNewAssignment(newAssign){
      try {
        let response = await axios.post(`${API_BASE_URL}/PauAssignment`, newAssign,  {
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.status === 200;
      } catch (error){
        console.error(error);
        return false;
      }
    }
    
    static async postNewMetric(metric){
      try{
        let response = await axios.post(`${API_BASE_URL}/Metric`, metric, {
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.status === 200;
      }catch (error){
        console.error(error);
        return false;
      }
    }

    static async postNewOptimizationRequest(requestObj){
      try{
        let response = await axios.post(`${API_BASE_URL}/Optimization/Request`, requestObj);
        return response.data;
      } catch (error){
        console.error(error);
        return null;
      }
    }

    static async postNewCurrentDeployment(solutionId){
      try {
        let response = await axios.post(`${API_BASE_URL}/Organization/CurrentDeploy/${solutionId}`, {}, {
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.status === 200;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async postNewUser(email, username, role){
      try {
        let response = await axios.post(`${API_BASE_URL}/User/new`, {}, {
          params: {
            email: email,
            username: username,
            roleType: role
          }
        });
        return response.data;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async postUserRoleUpdate(userId, newRoleType){
      try {
        let response = await axios.post(`${API_BASE_URL}/User/UpdateRole`, {}, {
          params: {
            userId: userId,
            newRoleType: newRoleType
          }
        });
        return response.status === 200;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async postSendWelcomeEmail(toWelcomeId){
      try{
        let response = await axios.post(`${API_BASE_URL}/User/WelcomeEmail`, {}, {
          params: {
            id: toWelcomeId
          }
        });
        return response.data;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    // static async postLoginAttempt(loginObj){
    //   try {
    //     let response = await axios.post(`${API_BASE_URL}/User/Login`, loginObj);
    //     console.log(response);
    //     return response.status === 200;
    //   }catch(error){
    //     console.error(error);
    //     return false;
    //   }
    // }

    //end posts

    // Delete Requests //
    static async deleteSolution(id){
      try {
        let response = await axios.delete(`${API_BASE_URL}/Solution/${id}`);
        return response.status === 200;
      } catch (error) {
        console.error(error);
        return false;
      }
    }

    static async deleteAssign(id){
      try {
        let response = await axios.delete(`${API_BASE_URL}/PauAssignment/${id}`, {
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.status === 200;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async deleteMetric(id){
      try {
        let response = await axios.delete(`${API_BASE_URL}/Metric/${id}`, {
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.data;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async deleteOptimization(id){
      try {
        let response = await axios.delete(`${API_BASE_URL}/Optimization/Request/${id}`,{
          headers: {
            "ApiKey": this.ApiKey
          }
        });
        return response.status === 200;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async deleteErrorOptimization(id){
      try {
        let response = await axios.delete(`${API_BASE_URL}/Optimization/Request/Error/${id}`);
        return response.status === 200;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async deleteFullOptimization(id){
      try{
        let response = await axios.delete(`${API_BASE_URL}/Optimization/Request/Full/${id}`);
        return response.status === 200;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    static async deleteUser(id){
      try {
        let response = await axios.delete(`${API_BASE_URL}/User/${id}`);
        return response.data === true;
      }catch(error){
        console.error(error);
        return false;
      }
    }

    //misc
    static async ALogin(key){
      try {
        let jsonKey = JSON.stringify(key);
        let response = await axios.post(`${API_BASE_URL}/User/Alogin`, jsonKey, {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        );
        return response.data;
      } catch (error) {
        console.error(error);
        return false;
      }
    }

    static async postOptLogin(pw){
      try {
        let jsonKey = JSON.stringify(pw);
        let response = await axios.post(`${API_BASE_URL}/User/OptLogin`, jsonKey, {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        );
        return response.data;
      } catch (error) {
        console.error(error);
        return false;
      }
    }

    // static async sendTestEmail(){
    //   try {
    //     let response = await axios.post(`${API_BASE_URL}/User/SendTestEmail`);
    //     return response.status === 200;
    //   }catch (error) {
    //     console.error(error);
    //     return false;
    //   }
    // }




}